export const trackEvent = (action, category, label = '', value = null) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            ...(value !== null && { value }),
        });
    } else {
        console.warn('gtag is not available');
    }
};